import { render, staticRenderFns } from "./approval-tab.vue?vue&type=template&id=060aa165"
import script from "./approval-tab.vue?vue&type=script&lang=js"
export * from "./approval-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports